const paths = {
  plane: "M2 12l19-7-7 19-3-8-9-4z",
  check: "M4 12l5 5 11-11",
  warehouse: "M3 21V10l9-6 9 6v11H3zM8 21v-7h8v7",
  truck: "M2 17h11V6H2v11zm11-8h4l4 4v4h-8V9zM6 20a2 2 0 100-4 2 2 0 000 4zm12 0a2 2 0 100-4 2 2 0 000 4z",
  box: "M3 7l9-4 9 4-9 4-9-4zm0 0v10l9 4m0-14v14m9-14v10l-9 4",
  calendar: "M4 5h16v16H4V5zm0 5h16M8 3v4M16 3v4",
  chain: "M9 15l6-6M8 10L5.5 12.5a3.5 3.5 0 105 5L13 15M11 14l2.5-2.5a3.5 3.5 0 10-5-5L6 9",
  factory: "M3 21V11l5 3v-3l5 3V8l5 3v10H3zM7 21v-4M12 21v-4M17 21v-4",
  bolt: "M13 2L3 14h7l-1 8 11-14h-7l1-6z",
  oil: "M12 3c2.5 3 5 6 5 9.5a5 5 0 11-10 0C7 9 9.5 6 12 3z",
  construction: "M3 21h18M6 21V10l6-5 6 5v11M10 21v-6h4v6",
  car: "M4 17h16M5 17l1.5-5h11L19 17M8 17a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm11 0a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z",
  cart: "M3 4h2l2.5 12h10L20 8H6M9 20a1 1 0 100-2 1 1 0 000 2zm8 0a1 1 0 100-2 1 1 0 000 2z",
  phone: "M6 2h6v20H6zM9 19h.01",
  calendar2: "M4 5h16v16H4V5zm0 5h16M8 3v4M16 3v4M9 14h2m2 0h2",
  bank: "M3 10l9-6 9 6M4 10v10M20 10v10M4 20h16M9 13v5M12 13v5M15 13v5",
  ball: "M12 2a10 10 0 100 20 10 10 0 000-20zM12 2v20M2 12h20M5 5l14 14M19 5L5 19",
  handshake: "M2 12l4-4 4 2 4-4 8 8-3 3-2-2-3 3-2-2-3 3z",
  users: "M8 14a4 4 0 100-8 4 4 0 000 8zM2 21c0-3.3 2.7-6 6-6s6 2.7 6 6M17 11a3 3 0 100-6 3 3 0 000 6zM22 21c0-2.8-2-5.2-4.7-5.8",
  bulb: "M9 18h6M10 22h4M12 2a7 7 0 00-4 12.7c.6.5 1 1.3 1 2.1v.2h6v-.2c0-.8.4-1.6 1-2.1A7 7 0 0012 2z",
  leaf: "M4 20c8-1 14-6 16-16C10 5 5 11 4 20z",
  globe: "M12 2a10 10 0 100 20 10 10 0 000-20zM2 12h20M12 2c2.5 2.7 4 6.4 4 10s-1.5 7.3-4 10c-2.5-2.7-4-6.4-4-10s1.5-7.3 4-10z",
  mail: "M3 5h18v14H3V5zm0 0l9 7 9-7",
  phoneCall: "M5 4h4l2 5-2.5 1.5a11 11 0 005 5L15 13l5 2v4a2 2 0 01-2 2A16 16 0 013 6a2 2 0 012-2z",
  pin: "M12 22s7-6.5 7-12a7 7 0 10-14 0c0 5.5 7 12 7 12zM12 13a3 3 0 100-6 3 3 0 000 6z",
  arrowRight: "M5 12h14M13 6l6 6-6 6",
};

export default function Icon({ name, size = 24, strokeWidth = 1.8, className = "" }) {
  const d = paths[name] || paths.box;
  return (
    <svg
      className={`icon icon-${name} ${className}`}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d={d} />
    </svg>
  );
}
